import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import CLWSAuthZCaller from './exportable/CLWSAuthZCaller';
import store from './store';

const CLWSCallerApp = ({ isPageAuthorized, authorizationDispatch }) => (
  <Provider store={store}>
    {isPageAuthorized && (
      <CLWSAuthZCaller authorizationDispatch={authorizationDispatch} />
    )}
    {/* {Add a Caller Component here to render on app load irrespective of visiting home page routes} */}
  </Provider>
);

export default CLWSCallerApp;

CLWSCallerApp.propTypes = {};
